import { Injectable} from "@angular/core";

@Injectable()
export class MessageService {

    ciudadPromocionContacto=null;
    promocionId=null;
    ciudadEvento="";
    asesorEvento="";
    getCiudadPromocionContacto(){
        return this.ciudadPromocionContacto;
    }

    setCiudadPromocionContacto(ciudad){
        this.ciudadPromocionContacto = ciudad;
    }

    setPromocionId(promocion){
        this.promocionId = promocion;
    }

    getPromocionId() {
        return this.promocionId;
    }

    setCIudadEventos(ciudad) {
        this.ciudadEvento = ciudad;
    }

    getCiudadEventos() {
        return this.ciudadEvento;
    }

    setAsesorEventos(asesor){
        this.asesorEvento = asesor;
    }

    getAsesorEventos() {
        return this.asesorEvento;
    }

}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/services/MessageService.ts